import { render, staticRenderFns } from "./recharge_detail.vue?vue&type=template&id=2928c968&scoped=true"
import script from "./recharge_detail.vue?vue&type=script&lang=js"
export * from "./recharge_detail.vue?vue&type=script&lang=js"
import style0 from "./recharge_detail.vue?vue&type=style&index=0&id=2928c968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2928c968",
  null
  
)

export default component.exports